module.exports = __webpack_public_path__ + "img/stock4.deb843d7.png";